import UrlPattern from 'url-pattern';

const construct = url => new UrlPattern('(*)' + url);

export const OPD_USERLINK = construct('/v3/opd/userlink');
export const OPD_SUBMIT = construct('/v3/opd/confirm');
export const CANCEL_OPD = construct('/v3/opd/reject');
